export default "__VITE_ASSET__Pa$qWq9E__"